export class CampaignMessage {
    constructor({
        channel,
        type,
        name = '<Name of message>',
        index,
        isDeleted = false,
        subject = '',
        body = '',
        wait = 0,
    }) {
        this.channel = channel;
        this.type = type;
        this.name = name;
        this.index = index;
        this.isDeleted = isDeleted;
        this.subject = subject;
        this.body = body;
        this.wait = wait;
    }
}
